import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/lib/components/google-analytics-defer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/vercel/path0/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/packages/ui/src/toaster.tsx");
